import { render } from "./DateFormWithValidation.vue?vue&type=template&id=0ddacaaa"
import script from "./DateFormWithValidation.vue?vue&type=script&lang=js"
export * from "./DateFormWithValidation.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__